/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Identifies the situation familiale options
 */
enum SituationFamiliale {
  Celibataire = 'celibataire',
  Marie = 'marie',
  Divorce = 'divorce',
  SepareDeCorps = 'separe-de-corps',
  Concubinage = 'concubinage',
  Veuf = 'veuf',
  SepareDeFait = 'separe-de-fait',
  Remarie = 'remarie',
  PACS = 'pacte-civil-de-solidarite',
  AutreSituation = 'autre-situation',
}

export default SituationFamiliale;
